.panel {
  grid-column: 1 / -1;
  display: grid;
  gap: 8px;
  min-width: 0;
}

.row {
  display: grid;
  gap: 6px;
  padding: var(--pad);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--panel);
  min-width: 0;
}

/* A stopped feed gets the heavier edge and the tint; the words (the pill and the sentence) carry
   the meaning, the colour only helps the eye find it. */
.stopped {
  border-color: var(--crit-line);
  background: var(--crit-w);
}

.expiring {
  border-color: var(--warn-line);
  background: var(--warn-w);
}

.head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.name {
  margin: 0;
  color: var(--ink);
  font-size: var(--t-head);
  font-weight: 600;
  overflow-wrap: anywhere;
}

.said {
  margin: 0;
  max-width: 90ch;
  color: var(--ink-2);
  font-size: var(--t-dense);
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.meta {
  margin: 0;
  color: var(--muted);
  font-size: var(--t-min);
  line-height: 1.5;
}

.form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 10px;
  margin-top: 4px;
}

.field {
  display: grid;
  gap: 4px;
  color: var(--ink-2);
  font-size: var(--t-label);
}

.field input {
  min-width: 14rem;
  height: var(--h-ctl);
  padding: 0 8px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
}

.field input:focus-visible,
.renew:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.renew {
  height: var(--h-ctl);
  padding: 0 12px;
  border: 1px solid var(--accent);
  border-radius: var(--radius-ctl);
  background: var(--accent);
  color: var(--on-fill);
  font: inherit;
  font-size: var(--t-label);
  cursor: pointer;
}

.renew:disabled {
  border-color: var(--btn-off-bg);
  background: var(--btn-off-bg);
  color: var(--btn-off-ink);
  cursor: not-allowed;
}

.note {
  margin: 0;
  color: var(--muted);
  font-size: var(--t-min);
}
